<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card class="detalle">
      <v-card-title>
        <span class="text-h5">{{ $t("view.commons.detail") }}</span>
        <v-spacer />
        <v-btn fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.close')" @click="dialog = false">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-md class="px-0 py-0 detalle-dialog">
          <v-layout row wrap>
            <v-flex md6>
              <v-list three-line subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("view.filetransaction.validator.detalle.nombre") }}</v-list-item-title>
                    <v-list-item-subtitle>{{ file.nombre }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-list three-line subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("view.filetransaction.validator.detalle.subtipo") }}</v-list-item-title>
                    <v-list-item-subtitle>{{ file.subtipo }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-flex>

            <v-flex md6>
              <v-list three-line subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("view.filetransaction.validator.detalle.fecha") }}</v-list-item-title>
                    <v-list-item-subtitle>{{ file.fecha }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-list three-line subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("view.filetransaction.validator.detalle.id") }}</v-list-item-title>
                    <v-list-item-subtitle>{{ file.clave }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex md12 class="py-0 px-1 my-0">
              <v-divider />
            </v-flex>
            <v-flex v-for="(item, index) in file.detalle" :key="index" md6 class="py-0 my-0">
              <v-list three-line subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(`view.filetransaction.validator.detalle.${index}`) }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import tippy from "tippy.js";

export default {
  name: "DetalleModal"
  , data() {
    return {
      titleModal: this.$t("view.commons.detail")
      , dialog: false
      , file: {
        nombre: ""
        , subtipo: ""
        , fecha: ""
        , clave: ""
        , detalle: {}
      }
    };
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    open(file) {
      this.file = file;
      this.dialog = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.detalle-dialog .v-card__title {
  padding: 16px 30px;
}
.detalle-dialog .v-list--three-line .v-list-item {
  height: 70px;
}
.detalle-dialog .v-list {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/filetransaction/validator/DetalleModal.vue